const now = new Date();
const day = 24 * 60 * 60 * 1000;

export const mockRoles = [
  {
    id: 'role-security',
    name: 'IHI Global Security',
    created_at: now,
    created_by: 'mock',
    modified_at: now,
    modified_by: 'mock',
  },
  {
    id: 'role-admin',
    name: 'Site Admin',
    created_at: now,
    created_by: 'mock',
    modified_at: now,
    modified_by: 'mock',
  },
  {
    id: 'role-traveler',
    name: 'Traveler',
    created_at: now,
    created_by: 'mock',
    modified_at: now,
    modified_by: 'mock',
  },
];

export const mockCountries = [
  { id: 'country-jp', name: 'Japan' },
  { id: 'country-th', name: 'Thailand' },
  { id: 'country-sg', name: 'Singapore' },
  { id: 'country-us', name: 'United States' },
  { id: 'country-gb', name: 'United Kingdom' },
];

export const mockCompanies = [
  {
    id: 'company-ihi',
    name: 'IHI Corporation',
    code: 'IHI',
    emaildomain: '@ihi.co.jp',
    email: 'contact@ihi.co.jp',
    phone: '+81 3-6204-8000',
    address: '1 Toyosu, Koto-ku, Tokyo',
    countryid: 'country-jp',
    country: 'Japan',
    created_at: now,
    created_by: 'mock',
    modified_at: now,
    modified_by: 'mock',
  },
  {
    id: 'company-th',
    name: 'IHI Asia Pacific Thailand',
    code: 'IHI-TH',
    emaildomain: '@ihi.co.th',
    email: 'contact@ihi.co.th',
    phone: '+66 2-123-4567',
    address: 'Bangkok, Thailand',
    countryid: 'country-th',
    country: 'Thailand',
    created_at: now,
    created_by: 'mock',
    modified_at: now,
    modified_by: 'mock',
  },
  {
    id: 'company-sg',
    name: 'IHI Asia Pacific',
    code: 'IHI-SG',
    emaildomain: '@ihi-ap.com',
    email: 'contact@ihi-ap.com',
    phone: '+65 6220 1234',
    address: 'Singapore',
    countryid: 'country-sg',
    country: 'Singapore',
    created_at: now,
    created_by: 'mock',
    modified_at: now,
    modified_by: 'mock',
  },
];

export const mockGroups = [
  { id: 'group-hq', name: 'Headquarters', totalUsers: 2, totalTrips: 2, totalEmergencyAlerts: 1 },
  {
    id: 'group-apac',
    name: 'APAC Travelers',
    totalUsers: 2,
    totalTrips: 2,
    totalEmergencyAlerts: 0,
  },
  {
    id: 'group-security',
    name: 'Global Security',
    totalUsers: 1,
    totalTrips: 1,
    totalEmergencyAlerts: 0,
  },
];

const userBase = {
  languageid: 'lang-en',
  language: 'English',
  avatarurl: '',
  managedcountriesname: 'Japan, Thailand, Singapore',
  managedcountries: mockCountries.slice(0, 3),
  secondment: false,
  needPasswordChange: false,
  needchangepassword: false,
  isemergencycontact: false,
  created_at: now,
  created_by: 'mock',
  modified_at: now,
  modified_by: 'mock',
  nationalityid: 'country-jp',
  nationality: 'Japanese',
  dob: '1985-06-15',
  passport: 'MOCK12345',
  isActive: true,
};

export const mockUsers: any[] = [
  {
    ...userBase,
    id: 'user-security',
    usercode: 'IHI-000001',
    email: 'security.mock@ihi.co.jp',
    firstname: 'Aiko',
    lastname: 'Tanaka',
    fullname: 'Aiko Tanaka',
    phone: '+81 90-1000-1000',
    companyid: 'company-ihi',
    company: 'IHI Corporation',
    country: 'Japan',
    position: 'Security Manager',
    division: 'Global Security',
    roleid: 'role-security',
    role: 'IHI Global Security',
    groupsname: 'Global Security',
    groups: [{ id: 'group-security', name: 'Global Security' }],
    trips: 1,
    isemergencycontact: true,
  },
  {
    ...userBase,
    id: 'user-admin',
    usercode: 'IHI-000002',
    email: 'admin.mock@ihi.co.th',
    firstname: 'Narin',
    lastname: 'Chai',
    fullname: 'Narin Chai',
    phone: '+66 81-200-2000',
    companyid: 'company-th',
    company: 'IHI Asia Pacific Thailand',
    country: 'Thailand',
    position: 'Site Administrator',
    division: 'Operations',
    roleid: 'role-admin',
    role: 'Site Admin',
    groupsname: 'APAC Travelers',
    groups: [{ id: 'group-apac', name: 'APAC Travelers' }],
    trips: 2,
  },
  {
    ...userBase,
    id: 'user-traveler-1',
    usercode: 'IHI-000003',
    email: 'hiroshi.mock@ihi.co.jp',
    firstname: 'Hiroshi',
    lastname: 'Sato',
    fullname: 'Hiroshi Sato',
    phone: '+81 90-3000-3000',
    companyid: 'company-ihi',
    company: 'IHI Corporation',
    country: 'Japan',
    position: 'Senior Engineer',
    division: 'Engineering',
    roleid: 'role-traveler',
    role: 'Traveler',
    groupsname: 'Headquarters',
    groups: [{ id: 'group-hq', name: 'Headquarters' }],
    trips: 1,
  },
  {
    ...userBase,
    id: 'user-traveler-2',
    usercode: 'IHI-000004',
    email: 'mei.mock@ihi-ap.com',
    firstname: 'Mei',
    lastname: 'Lim',
    fullname: 'Mei Lim',
    phone: '+65 9000 4000',
    companyid: 'company-sg',
    company: 'IHI Asia Pacific',
    country: 'Singapore',
    position: 'Project Manager',
    division: 'Projects',
    roleid: 'role-traveler',
    role: 'Traveler',
    groupsname: 'APAC Travelers',
    groups: [{ id: 'group-apac', name: 'APAC Travelers' }],
    trips: 0,
  },
];

const destination = (
  id: string,
  origin: string,
  destinationCountry: string,
  departureOffset: number,
  arrivalOffset: number,
) => ({
  destination_id: id,
  is_arrived_origin: departureOffset < 0,
  scheduled_departure: new Date(now.getTime() + departureOffset * day),
  airline_name: 'Mock Airways',
  destination_country: destinationCountry,
  is_arrived_destination: arrivalOffset < 0,
  origin_timezone: '+09:00',
  arrived_time_destination:
    arrivalOffset < 0 ? new Date(now.getTime() + arrivalOffset * day) : undefined,
  created_at: new Date(now.getTime() - 10 * day),
  flight_number: `MOCK-${id}`,
  destination_timezone: '+07:00',
  destination_airport_code: destinationCountry === 'Thailand' ? 'BKK' : 'SIN',
  updated_at: now,
  arrived_time_origin:
    departureOffset < 0 ? new Date(now.getTime() + departureOffset * day) : undefined,
  origin_country: origin,
  origin_airport_code: origin === 'Japan' ? 'HND' : 'SIN',
  destination_airport_name: `${destinationCountry} International Airport`,
  origin_airport_name: `${origin} International Airport`,
  airline_logo: '',
  scheduled_arrival: new Date(now.getTime() + arrivalOffset * day),
  issues: [],
  origin_timezone_name: 'Asia/Tokyo',
  destination_timezone_name: destinationCountry === 'Thailand' ? 'Asia/Bangkok' : 'Asia/Singapore',
  hotel_name: 'Mock Business Hotel',
  room_number: '1204',
  scheduled_arrival_converted: new Date(now.getTime() + arrivalOffset * day).toISOString(),
  scheduled_departure_converted: new Date(now.getTime() + departureOffset * day).toISOString(),
});

export const mockTrips: any[] = [
  {
    company_name: 'IHI Corporation',
    created_at: new Date(now.getTime() - 7 * day),
    email: 'hiroshi.mock@ihi.co.jp',
    full_name: 'Hiroshi Sato',
    groups: 'Headquarters',
    id: '040b6c51-2c71-f111-ab0e-6045bd1cea28',
    label: 'Tokyo to Bangkok',
    trip_label: 'Tokyo to Bangkok',
    status: 'ONGOING',
    user_id: 'user-traveler-1',
    confirm_safety: true,
    no_response: false,
    current_country: 'Thailand',
    is_gps_enabled: true,
    destinations: [destination('101', 'Japan', 'Thailand', -2, -1)],
  },
  {
    company_name: 'IHI Asia Pacific Thailand',
    created_at: new Date(now.getTime() - day),
    email: 'admin.mock@ihi.co.th',
    full_name: 'Narin Chai',
    groups: 'APAC Travelers',
    id: 'trip-planned',
    label: 'Bangkok to Singapore',
    trip_label: 'Bangkok to Singapore',
    status: 'PLANNED',
    user_id: 'user-admin',
    confirm_safety: null,
    no_response: false,
    current_country: 'Thailand',
    is_gps_enabled: true,
    destinations: [destination('102', 'Thailand', 'Singapore', 2, 3)],
  },
  {
    company_name: 'IHI Corporation',
    created_at: new Date(now.getTime() - 30 * day),
    email: 'security.mock@ihi.co.jp',
    full_name: 'Aiko Tanaka',
    groups: 'Global Security',
    id: 'trip-completed',
    label: 'Tokyo to Singapore',
    trip_label: 'Tokyo to Singapore',
    status: 'COMPLETED',
    user_id: 'user-security',
    confirm_safety: true,
    no_response: false,
    current_country: 'Japan',
    is_gps_enabled: false,
    destinations: [destination('103', 'Japan', 'Singapore', -20, -19)],
  },
];

export const mockIssues = [
  {
    country: 'Thailand',
    status: 'Opened',
    latitude: '13.7563',
    longitude: '100.5018',
    updated_at: now.toISOString(),
    issue_id: 'issue-1',
    description: 'Traveler requested a safety check.',
    created_at: new Date(now.getTime() - 2 * 60 * 60 * 1000),
    airport_code: 'BKK',
    type: 'safety',
    created_at_converted: now.toISOString(),
    created_at_timezone: 'Asia/Bangkok',
  },
];

export const mockNews = [
  {
    title: 'Regional transport services operating normally',
    title_ja: '地域交通サービスは通常通り運行しています',
    description: 'Local transport and airports continue normal operations.',
    description_ja: '現地の交通機関と空港は通常通り運行しています。',
    thumbnail: 'assets/image/incident-news/thailand.png',
    url: 'https://example.com/mock-news-1',
    source: 'Mock News',
    publishedAt: now.toISOString(),
    country: 'Thailand',
  },
  {
    title: 'Weather advisory issued for Tokyo',
    title_ja: '東京に気象注意報',
    description: 'Travelers should monitor local forecasts before departure.',
    description_ja: '出発前に現地の天気予報を確認してください。',
    thumbnail: 'assets/image/incident-news/japan.png',
    url: 'https://example.com/mock-news-2',
    source: 'Mock News',
    publishedAt: new Date(now.getTime() - day).toISOString(),
    country: 'Japan',
  },
];

export const mockNotifications = [
  {
    body: 'Hiroshi Sato confirmed safety in Thailand.',
    created_at: now,
    icon: 'bx bx-check-shield',
    is_read: false,
    sender_id: 'system',
    sub_type: 'confirmed',
    title: 'Safety confirmed',
    type: 'confirm',
    updated_at: now,
    user_id: 'user-security',
    user_notification_id: 'notification-1',
    trip_id_reported: '040b6c51-2c71-f111-ab0e-6045bd1cea28',
    user_id_reported: 'user-traveler-1',
  },
];

export const mockLogs = [
  {
    id: 'log-1',
    timestamp: now.toISOString(),
    type: 'UPDATE',
    action: 'Updated alert configuration',
    fullname: 'Aiko Tanaka',
  },
  {
    id: 'log-2',
    timestamp: new Date(now.getTime() - day).toISOString(),
    type: 'CREATE',
    action: 'Created mock traveler',
    fullname: 'Aiko Tanaka',
  },
  {
    id: 'log-3',
    timestamp: new Date(now.getTime() - 2 * day).toISOString(),
    type: 'READ',
    action: 'Viewed trip details',
    fullname: 'Narin Chai',
  },
];

export const mockAlertConfiguration = {
  arrivalReminderFreq: 15,
  alertReminderFreq: 10,
  gpsFetchInterval: 15,
  keywords: 'security,travel,weather,airport',
};

export const mockUserInfo = mockUsers[0];
